/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    CommentWithVote,
    CommentWithVoteFromJSON,
    CommentWithVoteToJSON,
} from './';

/**
 * 
 * @export
 * @interface CommentSearchAdminResponse
 */
export interface CommentSearchAdminResponse {
    /**
     * Cursor to fetch next set of results.
     * @type {string}
     * @memberof CommentSearchAdminResponse
     */
    cursor?: string;
    /**
     * 
     * @type {Array<CommentWithVote>}
     * @memberof CommentSearchAdminResponse
     */
    results: Array<CommentWithVote>;
}

export function CommentSearchAdminResponseFromJSON(json: any): CommentSearchAdminResponse {
    return {
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        
        'results': (json['results'] as Array<any>).map(CommentWithVoteFromJSON),
        
    };
}

export function CommentSearchAdminResponseToJSON(value?: CommentSearchAdminResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'cursor': value.cursor,
        
        'results': (value.results as Array<any>).map(CommentWithVoteToJSON),
        
    };
}


